import React from 'react'
import { mount } from 'enzyme'
import TaxForm from '../forms/TaxForm'
import Form1040 from '../forms/Form1040'
import Form1065 from '../forms/Form1065'
import Form1120 from '../forms/Form1120'
import Form1120S from '../forms/Form1120S'

const forms = {
  '1120S': Form1120S,
  1120: Form1120,
  '1040C': Form1040,
  1065: Form1065
}
const taxFormProps = {
  onDataChange: () => {},
  year: 2018
}
describe('<TaxForm />', () => {
  it('should render the correct tax form based on its `form` prop', () => {
    for (const formName of Object.keys(forms)) {
      const wrapper = mount(<TaxForm defaults={{}} {...taxFormProps} form={formName} />)
      expect(wrapper.find(forms[formName]).length).toEqual(1)
    }
  })
})